export default __webpack_public_path__ + "083a600e1748945d2b53d616bba08924.png";